import http from '../utils/http';

import { chunkArray } from '../utils/utils';

import {
  CLEAR_COMMENTS,
  CLEAR_UNREAD_COMMENTS_NUMBER,
  SET_FETCHING_COMMENTS,
  SET_TOTAL_COMMENTS,
  SET_UNREAD_COMMENTS_NUMBER,
  SET_COMMENTS,
} from '../constants/actionTypes';

import { setFeedbackAction } from './feedback';

import {
  commentsUrl,
  numberOfUnreadCommentsUrl,
  clearNumberOfUnreadCommentsUrl,
} from '../constants/urls';

const setCommentsAction = comments => ({
  type: SET_COMMENTS,
  payload: comments,
});

const setTotalCommentsAction = total => ({
  type: SET_TOTAL_COMMENTS,
  payload: total,
});

const setNumberOfUnreadCommentsAction = number => ({
  type: SET_UNREAD_COMMENTS_NUMBER,
  payload: number,
})

const setFetchingCommentsAction = isFetching => ({
  type: SET_FETCHING_COMMENTS,
  payload: isFetching,
});

const clearUnreadCommentsNumberAction = () => ({ type: CLEAR_UNREAD_COMMENTS_NUMBER });

const clearCommentsAction = () => ({ type: CLEAR_COMMENTS });

export const getComments = (jobId, limit) =>
  async dispatch => {
    try {
      dispatch(setFetchingCommentsAction(true))
      const { data: response } = await http.get(commentsUrl(jobId));
      const [ chunkedComments, total ] = prepareComment(response.data, limit);

      dispatch(setCommentsAction(chunkedComments));
      dispatch(setTotalCommentsAction(total));
      dispatch(setFetchingCommentsAction(false));
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
      dispatch(setFetchingCommentsAction(false));
    }
};

export const getNumberOfUnreadComments = id =>
  async dispatch => {
    try {
      const { data: response } = await http.get(numberOfUnreadCommentsUrl(id));
      const numOfComments = response.data;

      dispatch(setNumberOfUnreadCommentsAction(numOfComments));
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
};

export const clearComments = () => dispatch => dispatch(clearCommentsAction());

export const clearUnreadCommentsNumber = jobId =>
  async dispatch => {
    try {
      await http.put(clearNumberOfUnreadCommentsUrl(jobId));
      dispatch(clearUnreadCommentsNumberAction());
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const addComment = (jobId, limit, comment) =>
  async dispatch => {
    try {
      const { data: response } = await http.post(commentsUrl(jobId),{text: comment});
      const [ chunkedComments, total ] = prepareComment(response.data, limit);

      dispatch(setCommentsAction(chunkedComments));
      dispatch(setTotalCommentsAction(total));
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

const prepareComment = (comments, limit) => {
  const chunkedComments = comments.length ? chunkArray(limit)(comments) : [];
  const total = comments ? comments.length : 0;

  return [chunkedComments, total];
}



// WEBPACK FOOTER //
// ./src/actions/conversation.js